import React, { useMemo, useState } from "react";
import { auditOutputs } from "../lib/audit";
import { ShieldCheck, ShieldAlert, X } from "lucide-react";
import * as m from "../lib/model";

// Live tie-out: re-derives every headline output of the deal on screen and flags any break.
export function TieOutBadge({ V, testid = "tie-out" }) {
  const [open, setOpen] = useState(false);
  const a = useMemo(() => auditOutputs(V), [V]);
  if (a.skipped) return null;
  const clean = a.clean;
  return (
    <>
      <button
        className={`tie-badge ${clean ? "ok" : "bad"}`}
        onClick={() => setOpen(true)}
        title={clean ? `${a.checks} outputs re-derived from first principles — all tie out` : `${a.fails.length} of ${a.checks} outputs do not tie out`}
        data-testid={testid}
      >
        {clean ? <ShieldCheck size={12} /> : <ShieldAlert size={12} />}
        {clean ? `Tie-out ${a.checks}/${a.checks}` : `${a.fails.length} break${a.fails.length > 1 ? "s" : ""}`}
      </button>
      {open && (
        <div className="modal-overlay" onMouseDown={() => setOpen(false)} data-testid={`${testid}-modal`}>
          <div className="modal-card tie-modal" onMouseDown={(e) => e.stopPropagation()}>
            <div className="modal-head">
              <div>
                <div className="modal-title">Formula tie-out</div>
                <div className="modal-sub">{a.checks} outputs on this view re-derived from first principles and compared to the model.</div>
              </div>
              <button className="icon-btn" onClick={() => setOpen(false)} data-testid={`${testid}-close`}><X size={14} /></button>
            </div>
            {clean ? (
              <div className="tie-clean" data-testid={`${testid}-clean`}>
                <ShieldCheck size={16} /> Every figure ties out — Sources &amp; Uses, debt service, DSCR, exit value, MOIC, IRR and the LP waterfall.
              </div>
            ) : (
              <table className="tbl tbl-tight" data-testid={`${testid}-breaks`}>
                <thead><tr><th>Check</th><th className="num">Model</th><th className="num">Re-derived</th><th className="num">Diff</th></tr></thead>
                <tbody>
                  {a.fails.map((f, i) => (
                    <tr key={i} data-testid={`${testid}-break-${i}`}>
                      <td>{f.label}</td>
                      <td className="num">{m.fmt$(f.model)}</td>
                      <td className="num">{m.fmt$(f.hand)}</td>
                      <td className="num exp">{m.fmt$(f.model - f.hand)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}
    </>
  );
}
